<template>
  <body class="hold-transition login-page">
    <div class="login-box">
      <div class="login-logo mt-5">
        <img width="100" :src="getLogo" alt="" />
      </div>
      <!-- /.login-logo -->
      <div class="card">
        <div class="card-body login-card-body">
          <p class="login-box-msg">Sign in to start your session</p>
          <p class="mt-2 text-center">
            Don't have an account yet?
            <br />
            <a class="text-info text-center" :href="BASE_URL + '/pricing'"
              >Try Ownaradio for FREE</a
            >
          </p>
          <ValidationObserver ref="observer" v-slot="{ invalid, passes }">
            <form @submit.prevent="passes(login)">
              <p class="alert alert-danger" v-if="errors.unauthorized">
                {{ errors.unauthorized[0] }}
              </p>
              <p class="alert alert-danger" v-if="errors.provider">
                {{ errors.provider[0] }}
              </p>
              <validation-provider
                name="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <div class="input-group mb-3">
                  <input
                    name="email"
                    v-model="form.email"
                    type="text"
                    class="form-control"
                    placeholder="Email"
                  />
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <span class="fas fa-envelope"></span>
                    </div>
                  </div>
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
              <validation-provider
                name="password"
                rules="required|min:8"
                v-slot="{ errors }"
              >
                <div class="input-group mb-3">
                  <input
                    name="password"
                    v-model="form.password"
                    type="password"
                    class="form-control"
                    placeholder="Password"
                  />
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <span class="fas fa-lock"></span>
                    </div>
                  </div>
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>

              <div class="row">
                <div class="col-8">
                  <div class="icheck-info">
                    <input class="mr-2" type="checkbox" id="remember" />
                    <label for="remember"> Remember Me </label>
                  </div>
                </div>
                <!-- /.col -->
                <div class="col-4">
                  <button
                    :disabled="invalid || loading || !onLine"
                    type="submit"
                    class="btn btn-info btn-block btn-flat"
                  >
                    {{ loading ? "loading..." : "Sign In" }}
                  </button>
                </div>
                <!-- /.col -->
              </div>
            </form>
            <div class="social-auth-links text-center mt-2 mb-3">
              <!-- <button 
              @click.prevent="FBlogin" 
               :disabled="loading || !onLine"
              class="btn btn-block btn-primary">
                <i class="fab fa-facebook mr-2"></i> Sign in using Facebook
              </button> -->

              <template v-if="!getAyoba()">
              <button
                :disabled="loading || !onLine"
                @click.prevent="loginWithGoogle"
                class="btn btn-block btn-outline-danger"
              >
                <i class="fab fa-google mr-2"></i> Sign in using Google
              </button>
            </template>

              <button
                :disabled="!onLine"
                @click.prevent="loginWithChenosis()"
                class="btn btn-block btn-success mt-3"
              >
              Sign in using
                <img
                  class="mr-3"
                  src="@/assets/chenosis.svg"
                  width="60"
                  alt=""
                />
                
              </button>
              <!-- <button
               :disabled="loading || !onLine"
                @click.prevent="loginWithTwitter"
                class="btn btn-block"
                style="background:teal;color:white"
              >
                <i class="fab fa-twitter mr-2"></i> Sign in using Twitter
              </button>
               <button
                :disabled="loading || !onLine"
                @click.prevent="loginWithLinkedIn"
              class="btn btn-block btn-outline-primary"
              >
                <i class="fab fa-linkedin-in mr-2"></i> Sign in using LinkedIn
              </button> -->
            </div>

            <p class="mt-3">
              <!-- <router-link class="text-info" to="/forgot-password">I Forgot My Password</router-link> -->
              <!-- <router-link class="text-info" to="#"
                >I Forgot My Password</router-link
              > -->
            </p>
            <chenosis-login-modal ref="chenosisLoginModal"></chenosis-login-modal>

          </ValidationObserver>
        </div>
        <!-- /.login-card-body -->
      </div>
    </div>
    <p v-if="getAyoba()" class="alert alert-sm mb-4">
      <img
        class="mr-2"
        src="@/assets/ayoba_logo.png"
        width="20"
        height="auto"
        alt=""
      />
      <a href="#" @click.prevent="startChat" target="__blank" class="text-info"
        >233 243 270 000</a
      >
      for enquiry.
    </p>

    <p v-else class="alert alert-sm mb-4">
      <i class="fab fa-whatsapp mr-2" aria-hidden="true"></i>
      <a
        target="__blank"
        class="text-info"
        href="https://wa.me/233243270000?text=Hello"
        >233 243 270 000</a
      >
      for enquiry.
    </p>

    <!-- /.login-box -->
  </body>
</template>

<script type="text/ecmascript-6">
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import { DISPATCH_LOGIN, REGISTER } from "@/store/action-types";
import { SET_AUTH_INFO } from "@/store/mutation-types";
import { initFacebookSdk } from "@/plugins/utils";
import ChenosisLoginModal from "@/components/ChenosisLoginModal.vue"

import ApiService from "@/plugins/ApiService";
export default {
  name: "Login",
  components: {
    ValidationObserver,
    ValidationProvider,
    ChenosisLoginModal
  },

  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      loading: false,
    };
  },

  computed: {
    ...mapState({
      errors: (state) => state.errors,
      onLine: (state) => state.auth.onLine,
    }),
    getLogo() {
      return require("@/assets/logo.svg");
    },
  },

  methods: {
    login() {
      this.loading = true;
      this.$store
        .dispatch(DISPATCH_LOGIN, this.form)
        .then(() => {
          // this.$router.go("/", ()=>{});
          this.$router.go("/", () => {});
        })
        .catch(() => {
          this.loading = false;
          this.$refs.observer.setErrors(this.errors);
        });
    },

    loginWithChenosis(){

      try {

        this.$refs.chenosisLoginModal.create('login')

      } catch (error) {
        console.log(error);
      
      }

      },

    // async FBlogin() {
    //   this.loading = true;
    //   FB.login(
    //     (response) => {
    //       if (response.authResponse) {
    //         FB.api(
    //           "/me/",
    //           { fields: "id, first_name, last_name, email" },
    //           (response) => {
    //             const form = {
    //               email: response.email,
    //               provider: "facebook",
    //               provider_user_id: response.id,
    //               name: response.first_name + " " + response.last_name,
    //               first_name: response.first_name,
    //               last_name: response.last_name,
    //               avatar: `https://graph.facebook.com/${response.id}/picture?type=normal`,
    //             };

    //             this.$store
    //               .dispatch(REGISTER, form)
    //               .then(() => {
    //                 this.$router.go("/", () => {});
    //               })
    //               .catch(() => {
    //                 this.loading = false;
    //                 this.$refs.observer.setErrors(this.errors);
    //               });
    //           }
    //         );
    //       }
    //     },
    //     { scope: "email" }
    //   );
    // },

    async loginWithGoogle() {
      try {
        this.loading = true;
        const GoogleUser = await this.$gAuth.signIn();

        const form = {
          email: GoogleUser.getBasicProfile().getEmail(),
          provider: "google",
          provider_user_id: GoogleUser.getId(),
          name: GoogleUser.getBasicProfile().getName(),
          first_name: GoogleUser.getBasicProfile().getGivenName(),
          last_name: GoogleUser.getBasicProfile().getFamilyName(),
          avatar: GoogleUser.getBasicProfile().getImageUrl(),
        };

        await this.$store.dispatch(DISPATCH_LOGIN, form);

        this.$router.go("/", () => {});
      } catch (error) {
        this.loading = false;
        this.$refs.observer.setErrors(this.errors);
      }
    },

    // async loginWithTwitter() {
    //   try {
    //     this.loading = true;
    //     const res = await ApiService.send("twitter/main/login", "get");

    //     window.location.href = res.data;
    //   } catch (error) {
    //     this.loading = false;
    //     console.log(error);
    //   }
    // },

    // async loginWithLinkedIn() {
    //   try {
    //     this.loading = true;
    //     const res = await ApiService.send("linkedin/main/login", "get");
    //     window.location.href = res.data;
    //   } catch (error) {
    //     this.loading = false;
    //     console.log(error);
    //   }
    // },

    async socialRedirect() {
      //not secure. try clearing browser history

      const params = new URL(document.location).searchParams;
      const userJSON = params.get("user");
      const access_token = params.get("access_token");
      if (userJSON && access_token) {
        const user = JSON.parse(userJSON);
        await this.$store.commit(SET_AUTH_INFO, { user, access_token });

        this.$router.go("/", () => {});
        // Replace the current entry in the browser's history with the home page
        // this.$router.replace("/"); this will replace the current url with
      }
    },
  },

  mounted() {
    // initFacebookSdk();
    this.socialRedirect();
  },
};
</script>
